const get = key => sessionStorage.getItem(key);
const set = (key, value) => sessionStorage.setItem(key, value);
const remove = (key, value) => sessionStorage.removeItem(key);

export default {
  get,
  set,
  remove
};
